var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AbfragerQuestionSide_1;
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerQuestionContainer } from './question/AbfragerQuestionContainer';
import { AbfragerAnswerContainer } from './answer/AbfragerAnswerContainer';
import { AbfragerAnswerPart } from './answer/AbfragerAnswerPart';
import { AbfragerAnswerBottom } from './answer/AbfragerAnswerBottom';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
let AbfragerQuestionSide = AbfragerQuestionSide_1 = class AbfragerQuestionSide extends React.PureComponent {
    render() {
        const { app, questionContainer, answerContainer, answerBottom } = this.props;
        return (React.createElement(Aspect_, { aspect: app.stage.inner, templateComponent: AbfragerQuestionSide_1.templateComponent },
            React.createElement(AbfragerQuestionContainer, { app: app }, questionContainer),
            React.createElement(AbfragerAnswerContainer, { app: app },
                React.createElement(AbfragerAnswerPart, { app: app }, answerContainer),
                React.createElement(AbfragerAnswerBottom, { app: app }, answerBottom))));
    }
    static get templateComponent() {
        return React.createElement("div", { className: "AbfragerQuestionSide" });
    }
};
__decorate([
    memoize
], AbfragerQuestionSide, "templateComponent", null);
AbfragerQuestionSide = AbfragerQuestionSide_1 = __decorate([
    observer
], AbfragerQuestionSide);
export { AbfragerQuestionSide };
